import { render } from "./DocEdit.vue?vue&type=template&id=315eed68&scoped=true&ts=true"
import script from "./DocEdit.vue?vue&type=script&lang=ts"
export * from "./DocEdit.vue?vue&type=script&lang=ts"

import "./DocEdit.vue?vue&type=style&index=0&id=315eed68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315eed68"]])

export default __exports__